import { useProperty, useSiteContext } from '@eti/providers';
import { useCallback, useEffect, useRef } from 'react';
import { css } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { createScript, removeScript } from '../utils/script';
import { jsx as _jsx } from "react/jsx-runtime";
const ratingWidgetStyle = css`
  height: 20px;
  margin-top: 16px;
  position: relative;
  width: 230px;

  iframe {
    height: 100%;
    left: -7px;
    width: 100%;
  }
`;
const THEME = {
  DARK: 'dark',
  LIGHT: 'light'
};
export const TrustpilotWidget = _ref => {
  let {
    businessId
  } = _ref;
  const {
    p
  } = useProperty();
  const {
    language
  } = useSiteContext();
  const trustBoxRef = useRef(null);
  const shouldUseDarkMode = p('CustomerWeb.UseDarkModeTheme.Enabled');
  const prefersDarkScheme = useMediaQuery('(prefers-color-scheme: dark)');
  const widgetTheme = prefersDarkScheme && shouldUseDarkMode ? THEME.DARK : THEME.LIGHT;
  const initializeWidget = useCallback(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustBoxRef.current);
    }
  }, []);
  useEffect(() => {
    if (trustBoxRef.current && !window.Trustpilot) {
      createScript(businessId, 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js', initializeWidget);
    } else {
      window.Trustpilot.loadFromElement(trustBoxRef.current);
    }
    return () => {
      removeScript(businessId);
    };
  }, [businessId, initializeWidget]);
  useEffect(() => {
    var _trustBoxRef$current;
    const iframe = (_trustBoxRef$current = trustBoxRef.current) === null || _trustBoxRef$current === void 0 ? void 0 : _trustBoxRef$current.querySelector('iframe');
    if (iframe) {
      iframe.remove();
    }
    setTimeout(() => {
      if (window.Trustpilot && trustBoxRef.current) {
        initializeWidget();
      }
    });
  }, [widgetTheme, initializeWidget]);
  return /*#__PURE__*/_jsx("div", {
    className: ratingWidgetStyle,
    "data-businessunit-id": businessId,
    "data-locale": language.locale,
    "data-template-id": "5419b637fa0340045cd0c936",
    "data-theme": widgetTheme,
    ref: trustBoxRef
  }, widgetTheme);
};
//# sourceMappingURL=TrustpilotWidget.js.map